// What the user is told when a request fails for a reason that is not their
// doing. Server faults never carry their real text to the screen - the details
// live in the server log.
export const GENERIC_ERROR_MESSAGE =
  "Something went wrong. Please try again, or contact support if the problem continues.";

export const NETWORK_ERROR_MESSAGE =
  "Could not reach the server. Check your connection and try again.";
